import PropTypes from 'prop-types'
import styled from 'styled-components'

import SidebarText from 'components/Shared/Sidebar/SidebarText/Index'

const Image = styled.img`
  width: 80px;
`
const SidebarLogo = ({ img, fallbackText }) => {
  return (
    img ? <Image src={img} /> : <SidebarText text={fallbackText} />
  )
}

SidebarLogo.propTypes = {
  fallbackText: PropTypes.string,
  img: PropTypes.string,
}

export default SidebarLogo
